import React from 'react';
import api from './../../../services/api';
import { cpfMask } from './CPFmask';
import { cepMask } from './CEPmask';
//import api_official from './../../../services/api_official';
import { withRouter } from 'react-router-dom';
import './../../../pages/Representante_Instituição/Tela_RI_Cadastro/styles.css';
import { validate } from 'gerador-validador-cpf'
import "./style.css";
import { Collapse } from "react-collapse";

//import da API
import { professional } from './../../../services/api';
let apiProfessional = new professional();


class Cadastro_ME extends React.Component {
    constructor() {
        super();
        this.state = {
            authenticated: false,
            name: "",
            crm: "",
            regional_council_state: "",
            phone: "",
            cpf: '',
            rg: "",
            federative_unit: "",
            address: "",
            cep: "",
            email: "",
            gender: "",
            birth: "",
            password: "",
            confirmPassword: "",
            occupation_area:"",
            medical_specialty: "",
            health_specialty: "",
            voluntary: "Profissional de saude",
            voluntary_type: "",
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleSelect_vt = this.handleSelect_vt.bind(this);
        this.handleSelect_ms = this.handleSelect_ms.bind(this);
        this.handleSelect_g = this.handleSelect_g.bind(this);
        this.handleSelect_uf1 = this.handleSelect_uf1.bind(this);
        this.handleSelect_uf2 = this.handleSelect_uf2.bind(this);
        this.handlechange = this.handlechange.bind(this)
        this.HandleChange = this.HandleChange.bind(this)
    }
    handleChange(evt) {
        this.setState({ [evt.target.name]: evt.target.value });
    }

    handleSelect(event) {
        this.setState({ occupation_area: event.target.value });
    }

    handleSelect_ms(event) {
        this.setState({ medical_specialty: event.target.value });
    }

    handleSelect_vt(event) {
        this.setState({ voluntary_type: event.target.value });
    }

    handleSelect_g(event) {
        this.setState({ gender: event.target.value });
    }

    handleSelect_uf1(event) {
        this.setState({ federative_unit: event.target.value });
    }

    handleSelect_uf2(event) {
        this.setState({ regional_council_state: event.target.value })
    }

    handlechange(e) {

        this.setState({ cpf: cpfMask(e.target.value) })
    }

    HandleChange(e) {

        this.setState({ cep: cepMask(e.target.value) })
    }

    handleSubmit = evt => {
        evt.preventDefault();

        const professional = {
            authenticated: this.state.authenticated,
            name: this.state.name,
            crm: this.state.crm,
            regional_council_state: this.state.regional_council_state,
            phone: this.state.phone,
            cpf: this.state.cpf,
            rg: this.state.rg,
            federative_unit: this.state.federative_unit,
            address: this.state.address,
            cep: this.state.cep,
            email: this.state.email,
            gender: this.state.gender,
            birth: this.state.birth,
            password: this.state.password,
            occupation_area: this.state.occupation_area,
            medical_specialty: this.state.medical_specialty,
            health_specialty: this.state.health_specialty,
            voluntary: this.state.voluntary,
            voluntary_type: this.state.voluntary_type,

        };
        const aux = {
            confirmPassword: this.state.confirmPassword
        }

        console.log(professional);
        // Validação de senha
        if (professional.password !== aux.confirmPassword) {
            alert("As senhas inseridas não são iguais!");
        } else {
            apiProfessional.create(professional)
                .then(res => {
                    console.log(res);
                    console.log(res.data);
                    alert("Usuário cadastrado com sucesso! Aguarde a aprovação de um organizador para poder utilizar a plataforma");
                    this.props.history.push("/login_m");
                })

                .catch(error => {
                    //console.log(error);
                    //console.log(error.data);
                });
        }
    }

    render() {
        const { cpf } = this.state
        const { cep } = this.state
        const renderAuthCPF = () => {
            if (cpf.length < 14) {
                return <p></p>
            }
            if ((validate(cpf) == false) && cpf.length == 14) {
                return <p id="invalid">CPF inválido!</p>
            } else {
                return <p id="valid">CPF válido!</p>
            }
        }
        var validator = require("email-validator");
        var email = validator.validate(this.state.email);
        var size = this.state.email
        const renderAuthEmail = () => {
            if (size.length < 6) {
                return <p></p>
            }
            if ((email == false) && (size.length > 6)) {
                return <p id="invalid">E-mail inválido!</p>
            }
            if (email == true) {
                return <p id="valid">E-mail válido!</p>
            }
        }

        return (
            <form onSubmit={this.handleSubmit} id="forms-RI-Cadastro">
                <h1 id="tittle-forms-cme">Formulário de Cadastro</h1>
                <br></br>

                <p id="RI-Title-Cadastro-Paciente" >E-mail</p>
                <input onChange={this.handleChange} name="email" placeholder="Insira seu e-mail: " id="RI-Cadastro" required />
                <>{renderAuthEmail()}</>
                <p id="RI-Title-Cadastro-Paciente" >Nome completo</p>
                <input onChange={this.handleChange} name="name" placeholder="Insira seu nome completo: " id="RI-Cadastro" required />

                <p id="RI-Title-Cadastro-Paciente" >Genêro</p>
                <select value={this.state.gender} onChange={this.handleSelect_g} id="RI-Solicitar-Forms" required>
                    <option></option>
                    <option value='Masculino'>Masculino</option>
                    <option value='Feminino'>Feminino</option>
                    <option value='Outro'>Outro</option>
                </select>

                <p id="RI-Title-Cadastro-Paciente" >Data de Nascimento</p>
                <input onChange={this.handleChange} type="date" name="birth" placeholder="Insira sua data de nascimento: " id="RI-Cadastro" required />

                <p id="RI-Title-Cadastro-Paciente" >RG</p>
                <input onChange={this.handleChange} name="rg" placeholder="Insira seu RG: " id="RI-Cadastro" required />

                <p id="RI-Title-Cadastro-Paciente" >Unidade Federativa</p>
                <select value={this.state.federative_unit} onChange={this.handleSelect_uf1} id="RI-Solicitar-Forms" required>
                    <option></option>
                    <option value="AC">Acre</option>
                    <option value="AL">Alagoas</option>
                    <option value="AP">Amapá</option>
                    <option value="AM">Amazonas</option>
                    <option value="BA">Bahia</option>
                    <option value="CE">Ceará</option>
                    <option value="DF">Distrito Federal</option>
                    <option value="ES">Espírito Santo</option>
                    <option value="GO">Goiás</option>
                    <option value="MA">Maranhão</option>
                    <option value="MT">Mato Grosso</option>
                    <option value="MS">Mato Grosso do Sul</option>
                    <option value="MG">Minas Gerais</option>
                    <option value="PA">Pará</option>
                    <option value="PB">Paraíba</option>
                    <option value="PR">Paraná</option>
                    <option value="PE">Pernambuco</option>
                    <option value="PI">Piauí</option>
                    <option value="RJ">Rio de Janeiro</option>
                    <option value="RN">Rio Grande do Norte</option>
                    <option value="RS">Rio Grande do Sul</option>
                    <option value="RO">Rondônia</option>
                    <option value="RR">Roraima</option>
                    <option value="SC">Santa Catarina</option>
                    <option value="SP">São Paulo</option>
                    <option value="SE">Sergipe</option>
                    <option value="TO">Tocantins</option>
                </select>

                <p id="RI-Title-Cadastro-Paciente" >CPF</p>
                <input onChange={this.handleChange} name="cpf" placeholder="Insira seu CPF: " id="RI-Cadastro" maxLength='14' value={cpf} onChange={this.handlechange} required />
                <>{renderAuthCPF()}</>
                <p id="RI-Title-Cadastro-Paciente" >Endereço</p>
                <input onChange={this.handleChange} name="address" placeholder="Insira seu endereço: " id="RI-Cadastro" required />

                <p id="RI-Title-Cadastro-Paciente" >CEP</p>
                <input onChange={this.handleChange} name="cep" placeholder="Insira seu CEP: " id="RI-Cadastro" maxLength='10' value={cep} onChange={this.HandleChange} required />

                <p id="RI-Title-Cadastro-Paciente" >Telefone</p>
                <input onChange={this.handleChange} name="phone" placeholder="Insira seu (DDD) e Telefone: " id="RI-Cadastro" required />

                <p id="RI-Title-Cadastro-Paciente" >Número do Conselho Profissional</p>
                <input onChange={this.handleChange} name="crm" placeholder="Insira seu Número do Conselho Profissional: " id="RI-Cadastro" required />

                <p id="RI-Title-Cadastro-Paciente" >UF do seu Número do Conselho Profissional</p>
                <select value={this.state.regional_council_state} onChange={this.handleSelect_uf2} id="RI-Solicitar-Forms" required>
                    <option></option>
                    <option value="AC">Acre</option>
                    <option value="AL">Alagoas</option>
                    <option value="AP">Amapá</option>
                    <option value="AM">Amazonas</option>
                    <option value="BA">Bahia</option>
                    <option value="CE">Ceará</option>
                    <option value="DF">Distrito Federal</option>
                    <option value="ES">Espírito Santo</option>
                    <option value="GO">Goiás</option>
                    <option value="MA">Maranhão</option>
                    <option value="MT">Mato Grosso</option>
                    <option value="MS">Mato Grosso do Sul</option>
                    <option value="MG">Minas Gerais</option>
                    <option value="PA">Pará</option>
                    <option value="PB">Paraíba</option>
                    <option value="PR">Paraná</option>
                    <option value="PE">Pernambuco</option>
                    <option value="PI">Piauí</option>
                    <option value="RJ">Rio de Janeiro</option>
                    <option value="RN">Rio Grande do Norte</option>
                    <option value="RS">Rio Grande do Sul</option>
                    <option value="RO">Rondônia</option>
                    <option value="RR">Roraima</option>
                    <option value="SC">Santa Catarina</option>
                    <option value="SP">São Paulo</option>
                    <option value="SE">Sergipe</option>
                    <option value="TO">Tocantins</option>
                </select>

                <p id="RI-Title-Cadastro-Paciente" >Qual sua área de atuação?</p>
                <select value={this.state.occupation_area} onChange={this.handleSelect} id="RI-Solicitar-Forms" required>
                    <option></option>
                    <option value='Medicina'>Medicina</option>
                    <option value='Psicologia'>Psicologia</option>
                    <option value='Fisioterapia'>Fisioterapia</option>
                    <option value='Odontologia'>Odontologia</option>
                    <option value='Enfermagem'>Enfermagem</option>
                    <option value='Nutrição'>Nutrição</option>
                    <option value='Outros'>Outros</option>
                </select>


                <Collapse isOpened={this.state.occupation_area === "Medicina"}>
                    <p id="RI-Title-Cadastro-Paciente" >Especialidade Médica</p>
                    <select value={this.state.medical_specialty} onChange={this.handleSelect_ms} id="RI-Solicitar-Forms">
                        <option></option>
                        <option value='Acupuntura'>Acupuntura</option>
                        <option value='Alergia e imunologia'>Alergia e imunologia</option>
                        <option value='Anestesiologia'>Anestesiologia</option>
                        <option value='Angiologia'>Angiologia</option>
                        <option value='Cardiologia'>Cardiologia</option>
                        <option value='Cirurgia cardiovascular'>Cirurgia cardiovascular</option>
                        <option value='Cirurgia da mão'>Cirurgia da mão</option>
                        <option value='Cirurgia de cabeça e pescoço'>Cirurgia de cabeça e pescoço</option>
                        <option value='Cirurgia do aparelho digestivo'>Cirurgia do aparelho digestivo</option>
                        <option value='Cirurgia geral'>Cirurgia geral</option>
                        <option value='Cirurgia oncológica'>Cirurgia oncológica</option>
                        <option value='Cirurgia pediátrica'>Cirurgia pediátrica</option>
                        <option value='Cirurgia plástica'>Cirurgia plástica</option>
                        <option value='Cirurgia torácica'>Cirurgia torácica</option>
                        <option value='Cirurgia vascular'>Cirurgia vascular</option>
                        <option value='Clínica médica'>Clínica médica</option>
                        <option value='Coloproctologia'>Coloproctologia</option>
                        <option value='Dermatologia'>Dermatologia</option>
                        <option value='Endocrinologia e metabologia'>Endocrinologia e metabologia</option>
                        <option value='Endoscopia'>Endoscopia</option>
                        <option value='Gastroenterologia'>Gastroenterologia</option>
                        <option value='Genética médica'>Genética médica</option>
                        <option value='Geriatria'>Geriatria</option>
                        <option value='Ginecologia e obstetrícia'>Ginecologia e obstetrícia</option>
                        <option value='Hematologia e hemoterapia'>Hematologia e hemoterapia</option>
                        <option value='Homeopatia'>Homeopatia</option>
                        <option value='Infectologia'>Infectologia</option>
                        <option value='Mastologia'>Mastologia</option>
                        <option value='Medicina de emergência'>Medicina de emergência</option>
                        <option value='Medicina de família e comunidade'>Medicina de família e comunidade</option>
                        <option value='Medicina do trabalho'>Medicina do trabalho</option>
                        <option value='Medicina de tráfego'>Medicina de tráfego</option>
                        <option value='Medicina esportiva'>Medicina esportiva</option>
                        <option value='Medicina física e reabilitação'>Medicina física e reabilitação</option>
                        <option value='Medicina intensiva'>Medicina intensiva</option>
                        <option value='Medicina legal e perícia médica'>Medicina legal e perícia médica</option>
                        <option value='Medicina nuclear'>Medicina nuclear</option>
                        <option value='Medicina preventiva e social'>Medicina preventiva e social</option>
                        <option value='Nefrologia'>Nefrologia</option>
                        <option value='Neurocirurgia'>Neurocirurgia</option>
                        <option value='Neurologia'>Neurologia</option>
                        <option value='Nutrologia'>Nutrologia</option>
                        <option value='Oftalmologia'>Oftalmologia</option>
                        <option value='Oncologia clínica'>Oncologia clínica</option>
                        <option value='Ortopedia e traumatologia'>Ortopedia e traumatologia</option>
                        <option value='Otorrinolaringologia'>Otorrinolaringologia</option>
                        <option value='Patologia'>Patologia</option>
                        <option value='Patologia clínica/medicina laboratorial'>Patologia clínica/medicina laboratorial</option>
                        <option value='Pediatria'>Pediatria</option>
                        <option value='Pneumologia'>Pneumologia</option>
                        <option value='Psiquiatria'>Psiquiatria</option>
                        <option value='Radiologia e diagnóstico por imagem'>Radiologia e diagnóstico por imagem</option>
                        <option value='Radioterapia'>Radioterapia</option>
                        <option value='Reumatologia'>Reumatologia</option>
                        <option value='Urologia'>Urologia</option>
                    </select>
                </Collapse>

                <Collapse isOpened={this.state.occupation_area !== "Medicina"}>
                    <p id="RI-Title-Cadastro-Paciente" >Especialidade na área da Saúde</p>
                    <input onChange={this.handleChange} name="health_specialty" placeholder="Caso atuante em áreas que não sejam medicina, qual a especialidade? " id="RI-Cadastro" />
                </Collapse>

                <p id="RI-Title-Cadastro-Paciente" >Tipo de voluntário</p>
                <select value={this.state.voluntary_type} onChange={this.handleSelect_vt} id="RI-Solicitar-Forms" required>
                    <option></option>
                    <option value='Atendimento in loco nas instituições (Presencial)'>Atendimento in loco nas instituições (Presencial)</option>
                    <option value='Atendimento via telessaúde (Online)'>Atendimento via telessaúde (Online)</option>
                    <option value='Ambos (Online e Presencial)'>Ambos (Online e Presencial)</option>
                </select>

                <p id="RI-Title-Cadastro-Paciente" >Senha</p>
                <input onChange={this.handleChange} name="password" placeholder="Insira uma senha: " id="RI-Cadastro" required/>
                <p id="RI-Title-Cadastro-Paciente" >Confirmar Senha</p>
                <input onChange={this.handleChange} name="confirmPassword" placeholder="Confirmar senha inserida:" id="RI-Cadastro" />
                
                <textarea rows="15" cols="50" input readOnly value={ ` Li e Aceito

Termo Profissionais de Saúde 

A plataforma Rede ConVida é um projeto, sem fins lucrativos, que visa exclusivamente conectar profissionais voluntários da área de saúde a pessoas em instituições de acolhimento, por meio de uma plataforma digital. Assim, é apenas uma facilitadora, no sentido de permitir que esses voluntários prestem, de forma autônoma e independente, serviços de telesaúde, como forma de contribuir para a diminuição da propagação do SARS-CoV-2, causador da COVID-19 (comumente conhecido como Coronavírus), diante da recomendação de redução de contato físico. 

Regulada pela Portaria n. 467 de 20 de março de 2020 do Ministério da Saúde, a telemedicina decorre de ações de interação à distância que podem contemplar o atendimento pré-clínico, suporte assistencial, consulta, monitoramente e diagnóstico, por meio de tecnologia de informação e comunicação. 

Os voluntários poderão realizar os atendimentos por meio da plataforma digital disponibilizada gratuitamente pela plataforma Rede ConVida de forma autônoma e independente e, por isso, não poderão, em nenhuma hipótese, ser considerados prepostos ou detentores de qualquer relação de subordinação com a plataforma Rede ConVida. 

Nos termos da Lei n. 9.608/1998, o voluntariado não será remunerado e não fará jus ao ressarcimento de eventuais despesas decorrentes da prestação do serviço oferecido. A prestação do serviço voluntário não gera vínculo empregatício ou qualquer obrigação de natureza trabalhista, previdenciária e afim. O voluntário que solicitar ou sugerir contraprestação de qualquer natureza por parte do paciente responderá civil e criminalmente de forma autônoma e exclusiva.

A responsabilidade pela condução das consultas, casos, diagnóstico, prescrição de tratamento, fornecimento de atestado, aviamento de receita e a preservação do sigilo das informações do paciente é exclusiva do voluntário responsável pelo atendimento. A plataforma Rede ConVida não interfere, aconselha ou supervisiona o tratamento sugerido ou implementado, não sendo, portanto, responsável pelas informações trocadas ou pelos atos praticados pelos voluntários ou pelos pacientes que utilizarem a plataforma digital.

A realização da consulta, orientação médica e prescrição de tratamento sempre ocorrerá sem nenhuma ingerência ou participação da plataforma Rede ConVida. Os voluntários devem avaliar cuidadosamente as informações que forem enviadas pelos pacientes, devendo pautar suas opiniões, recomendações ou prescrições de tratamento de acordo com a qualidade da informação recebida, cabendo-lhes aferir se ela é suficiente para tanto. 

O voluntário que realizar as ações pela plataforma da Rede ConVida deverá:
I –  estar autorizado para exercer a profissão no Brasil, com a devida inscrição no órgão de classe;
II atender e respeitar aos preceitos éticos de beneficência, não-maleficência, sigilo das informações e autonomia, cuidando e tratando todas as informações obtidas pelos respectivos pacientes que atender como se estivesse dentro do seu próprio consultório médico ou trabalhando em uma clínica, posto de saúde ou hospital;

III - observar as normas e orientações do Ministério da Saúde sobre notificação compulsória, em especial as listadas no Protocolo de Manejo Clínico do Coronavírus (COVID-19), disponível no endereço eletrônico do Ministério da Saúde (https://coronavirus.saude.gov.br/); 

IV – registrar na plataforma da Rede ConVida o prontuário médico do paciente, que deverá conter:
a)	Dados clínicos necessários à boa condução do caso, devendo ser preenchido em cada contato com o paciente;
b)	Data, hora, tecnologia da informação e comunicação utilizados para o atendimento; 
c)	Todas as informações repassadas pelo paciente, dentre elas, mídia e áudios;
d)	Número do registro perante o Conselho Regional Profissional e sua respectiva unidade da federação.

V – registrar na plataforma a orientação e tratamento sugerido ao paciente, com cópia da(s) receita(s) e/ou atestado(s) emitido(s). 

VI – Observar integralmente a legislação que rege a atividade por ele exercida, em especial, no caso dos médicos, a Lei 12.845, de 2013, bem como os respectivos Códigos de Ética e todas as normas e orientações do  Conselho Profissional  a que vinculados.

A coordenação do ConVida poderá alterar e realocar pacientes sem comunicação prévia.

A plataforma digital da Rede ConVida armazenará de forma sigilosa os prontuários dos pacientes onde constarão todas as informações por eles prestadas, bem como orientações, tratamentos e prescrições dadas pelos voluntários. Todos os acessos ao prontuário serão registrados e apenas os responsáveis por cada atendimento poderão ter, não o sendo concedido a qualquer outra pessoa, nem mesmo à coordenação da Rede ConVida que respeita e implanta todas as diretivas da Lei n. 13.7009/2018 - Lei Geral de Proteção de Dados. 

O voluntário declara ter ciência dos riscos advindos do tráfego de informações pela rede mundial de computadores (INTERNET), telefone e outra(s) ferramenta(s) tecnológica(s) de comunicação, isentando a Rede ConVida de tal responsabilidade. 

O profissional de saúde voluntário poderá divulgar a Rede ConVida para disseminar e capilarizar a plataforma, de modo a alcançar o maior número de potenciais pacientes e parcerias, sem que nada seja devido a este título. A divulgação deverá ser informada à Rede ConVida e interrompida imediatamente por solicitação expressa de qualquer representante da Rede ConVida. 

Por apenas disponibilizar uma plataforma digital para a aproximação virtual entre voluntários e potenciais pacientes usuários da plataforma, a RedeConvida é isenta de qualquer responsabilidade, independentemente da sua natureza, de modo que, na eventualidade de haver algum tipo de contestação, litígio ou responsabilidade, o respectivo voluntário deverá isentar a RedeConvida de qualquer responsabilidade, sendo assegurado, desde logo, o direito a regresso por parte da Rede ConVida.

Na eventualidade de a RedeConVida vier a ser acionada judicialmente ou extrajudicialmente por algo que não tenha dado causa, o respectivo profissional responsável deverá assumir para si toda a responsabilidade, isentando a Rede ConVida pela falta cometida pelo voluntário.

A prestação de serviços psicológicos realizados por meios de tecnologia da informação deverá atender ao disposto na Resolução n. 11 de 11 de maio de 2018 do Conselho Federal de Psicologia. 


 
Termo Paciente

A plataforma Rede ConVida é um projeto sem fins lucrativos que visa exclusivamente conectar profissionais voluntários da área de saúde à pessoas em instituições de acolhimento, por meio  de uma plataforma digital, para permitir que os médicos voluntários prestem de forma autônoma serviços de  telesaúde,  com forma de contribuir para diminuição da propagação do SARS-CoV-2, causador da COVID-19 (comumente conhecido como Coronavírus), diante da recomendação de redução de contato físico. 

Regulada pela Portaria n. 467 de 20 de março de 2020 do Ministério da Saúde, a telemedicina decorre de ações de interação à distância que podem contemplar o atendimento pré-clínico, suporte assistencial, consulta, monitoramente e diagnóstico, por meio de tecnologia de informação e comunicação. 

Os profissionais de saúde voluntários cadastrados poderão  realizar  os atendimentos por meio  da plataforma de forma independente, voluntária, gratuita, sem vínculo de trabalho e, em nenhuma hipótese, deverão ser considerados como  prepostos ou detentores de vínculo ou relação de subordinação com a Rede ConVida. 

Nos termos da Lei nº 9.608/1998, o voluntariado não será renumerado, nem  fará jus ao ressarcimento das despesas decorrentes da prestação do serviço oferecido. A prestação do serviço voluntário não gerará vínculo empregatício, nem obrigação de natureza trabalhista, previdenciária ou afim. É expressamente vedado a solicitação ou sugestão apresentada pelo profissional de saúde voluntário de contraprestação de qualquer natureza.

O paciente usuário tem conhecimento de que a realização da consulta, orientação médica e prescrição de tratamento ocorre sem nenhuma ingerência da Rede ConVida. 

O diagnóstico e prescrição de tratamento ocorrerá conforme as informações  fornecidas pelo paciente. É de responsabilidade exclusiva do paciente fornecer ao profissional de saúde informações verdadeiras, fornecendo todos os dados solicitados e necessários para o correto e preciso diagnóstico e orientação do tratamento mais apropriado. 

A responsabilidade pela condução dos casos, diagnóstico, prescrição de tratamento, aviamento de receita ou fornecimento de atestado é exclusiva do profissional de saúde responsável pelo atendimento do paciente. A Rede ConVida é apenas uma facilitadora da comunicação entre profissionais de saúde voluntários e pacientes,  sem interferir, aconselhar ou supervisionar o tratamento sugerido ou implementado, não sendo responsável pelas informações trocadas ou pelos atos praticados pelos voluntários e pelos pacientes que utilizarem a plataforma.

A coordenação do ConVida poderá alterar e realocar voluntários sem comunicação prévia.


A plataforma digital da Rede ConVida armazenará de forma sigilosa os prontuários dos pacientes onde constarão todas as informações por eles prestadas, bem como orientações, tratamentos e prescrições dadas pelos voluntários. Todos os acessos ao prontuário serão registrados e apenas os responsáveis por cada atendimento poderão ter, não o sendo concedido a qualquer outra pessoa, nem mesmo à coordenação da Rede ConVida que respeita e implanta todas as diretivas da Lei n. 13.7009/2018 - Lei Geral de Proteção de Dados.

Será mantida a confidencialidade das informações trocadas entre profissional da saúde voluntário e paciente. Caso o paciente seja encaminhado para outro profissional de saúde da mesma área ou não, este terá acesso as informações contidas no prontuário. 
Desde já, o paciente autoriza o compartilhamento destas informações aos profissionais de saúde encarregados.

O paciente declara ciência dos riscos advindos do tráfego de informações pela rede mundial de computadores (INTERNET), telefone e outra ferramenta tecnológica de comunicação, isentando a Rede ConVida de tal responsabilidade.

O paciente usuário declara ter ciência que a telemedicina e outras formas de atendimento à distância podem acarretar a limitação da percepção que é normalmente verificada nos atendimentos presencias, bem como que todo tratamento não caracteriza uma promessa de cura, mas apenas o meio para que, quando possível, ela seja atingida com amenização dos efeitos da doença.

O paciente é responsável por seguir integralmente as orientações e prescrições expedidas pelos Profissionais voluntários de saúde, especialmente no que tange à observância dos  tratamentos, procedimentos, isolamento,  horários e dosagem da medicação indicada.
 
O paciente expressa anuência e consentimento para a utilização da telesaúde, nos termos que lhe foram informados e explicados, ressaltando que foi devidamente esclarecido sobre o procedimento de consulta e atendimento virtual. 

O paciente usuário isenta a Rede ConVida de qualquer responsabilidade, independentemente da sua natureza, que poderá decorrer da consulta e orientação a ser prestada pelo profissional da saúde que fizer uso da plataforma digital Rede Convida. 

A prestação de serviços psicológicos realizado por meios de tecnologia da informação deverá atender o disposto na Resolução n. 11 de 11 de maio de 2018 do Conselho Federal de Psicologia. 



Termo Coordenador
 
A plataforma Rede ConVida é um projeto sem fins lucrativos que visa exclusivamente conectar profissionais voluntários da área de saúde à pessoas em instituições de acolhimento, por meio  de uma plataforma digital, para permitir que os médicos voluntários prestem de forma autônoma serviços de  telesaúde,  com forma de contribuir para diminuição da propagação do SARS-CoV-2, causador da COVID-19 (comumente conhecido como Coronavírus), diante da recomendação de redução de contato físico.  

Regulada pela Portaria n. 467 de 20 de março de 2020 do Ministério da Saúde, a telemedicina decorre de ações de interação à distância que podem contemplar o atendimento pré-clínico, suporte assistencial, consulta, monitoramente e diagnóstico, por meio de tecnologia de informação e comunicação.  

Os profissionais de saúde voluntários cadastrados poderão  realizar  os atendimentos por meio  da plataforma de forma independente, voluntária, gratuita, sem vínculo de trabalho e, em nenhuma hipótese, deverão ser considerados como  prepostos ou detentores de vínculo ou relação de subordinação com a Rede ConVida.  

Nos termos da Lei nº 9.608/1998, o voluntariado não será renumerado, nem  fará jus ao ressarcimento das despesas decorrentes da prestação do serviço oferecido. A prestação do serviço voluntário não gerará vínculo empregatício, nem obrigação de natureza trabalhista, previdenciária ou afim. É expressamente vedado a solicitação ou sugestão apresentada pelo profissional de saúde voluntário de contraprestação de qualquer natureza. 

O coordenador usuário tem conhecimento de que a realização da consulta, orientação médica e prescrição de tratamento ocorre sem nenhuma ingerência da Rede ConVida.  

O coordenador usuário será o responsável por cadastrar na plataforma os pacientes do instituto de sua responsabilidade e solicitar consultas de acordo com as demandas dos pacientes. É de responsabilidade exclusiva do coordenador inserir informações corretas e verdadeiras nas demandas que lhe são atribuídas, devendo fornecer todos os dados solicitados e necessários para o correto funcionamento do atendimento pela plataforma.

A responsabilidade pela condução dos casos, diagnóstico, prescrição de tratamento, aviamento de receita ou fornecimento de atestado é exclusiva do profissional de saúde responsável pelo atendimento do paciente. A Rede ConVida é apenas uma facilitadora da comunicação entre profissionais de saúde voluntários e pacientes,  sem interferir, aconselhar ou supervisionar o tratamento sugerido ou implementado, não sendo responsável pelas informações trocadas ou pelos atos praticados pelos voluntários e pelos pacientes que utilizarem a plataforma. 

A coordenação do ConVida poderá alterar e realocar voluntários sem comunicação prévia.  

A plataforma digital da Rede ConVida armazenará de forma sigilosa os prontuários dos pacientes onde constarão todas as informações por eles prestadas, bem como orientações, tratamentos e prescrições dadas pelos voluntários. Todos os acessos ao prontuário serão registrados e apenas os responsáveis por cada atendimento poderão ter, não o sendo concedido a qualquer outra pessoa, nem mesmo à coordenação da Rede ConVida que respeita e implanta todas as diretivas da Lei n. 13.7009/2018 - Lei Geral de Proteção de Dados. 

Será mantida a confidencialidade das informações trocadas entre profissional da saúde voluntário e paciente. Caso o paciente seja encaminhado para outro profissional de saúde da mesma área ou não, este terá acesso as informações contidas no prontuário.   

O coordenador declara ciência dos riscos advindos do tráfego de informações pela rede mundial de computadores (INTERNET), telefone e outra ferramenta tecnológica de comunicação, isentando a Rede ConVida de tal responsabilidade. 

O coordenador declara ter ciência e se compromete a informar aos pacientes que a telemedicina e outras formas de atendimento à distância podem acarretar a limitação da percepção que é normalmente verificada nos atendimentos presencias, bem como que todo tratamento não caracteriza uma promessa de cura, mas apenas o meio para que, quando possível, ela seja atingida com amenização dos efeitos da doença. 

A plataforma Rede ConVida é isenta de qualquer responsabilidade, independentemente da sua natureza, que poderá decorrer da consulta e orientação a ser prestada pelo profissional da saúde que fizer uso da plataforma digital Rede Convida.  

A prestação de serviços psicológicos realizado por meios de tecnologia da informação deverá atender o disposto na Resolução n. 11 de 11 de maio de 2018 do Conselho Federal de Psicologia.  
`}>

                </textarea>

                <br></br>
                <div>
                    <input type="checkbox" id="termos" name="termos" value="Termos" required />
                    <label for="termos"> Li e aceito os termos e condições</label>
                </div>

                <br></br>

                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button onClick={() => this.handleSubmit} id="RI-Cadastro">Enviar</button>
                </div>

            </form>
        );
    }
}

Cadastro_ME = withRouter(Cadastro_ME);
export default Cadastro_ME;

